import styled from "styled-components";
import { Box, Flex, Text } from "rebass/styled-components";

export const ModalContainer = styled(Box)`
  background: ${({ theme }) => theme.colors.navy600};
  border-radius: 16px;
  max-width: 460px;
  width: 90vw;
`;

export const ModalHeader = styled(Flex)`
  align-items: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.colors.navy50};
  justify-content: space-between;
  padding: 20px 24px;
`;

export const HeaderTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 20px;
  font-weight: 600;
`;

export const HeaderSubtitle = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  line-height: 1.4;
  padding-top: 4px;
`;

export const CloseButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 32px;
  justify-content: center;
  transition: all 0.15s ease;
  width: 32px;

  &:hover {
    background: ${({ theme }) => theme.colors.navy50};
    color: ${({ theme }) => theme.colors.ice};
  }
`;

export const ModalBody = styled(Box)`
  padding: 24px;
`;

export const InfoCard = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.navy};
  border: 1px solid ${({ theme }) => theme.colors.envyAlpha20};
  border-radius: 10px;
  gap: 16px;
  min-width: 0;
  padding: 16px;
`;

export const InfoIconWrapper = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.envyAlpha10};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.envy};
  flex-shrink: 0;
  height: 48px;
  justify-content: center;
  width: 48px;
`;

export const InfoTextContent = styled(Box)`
  min-width: 0;
`;

export const InfoTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: Barlow;
  font-size: 16px;
  font-weight: 600;
`;

export const InfoDescription = styled(Text)`
  color: ${({ theme }) => theme.colors.shade300};
  font-family: Barlow;
  font-size: 14px;
  line-height: 1.4;
  padding-top: 4px;
`;

export const ModalFooter = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.navy200};
  flex-direction: column;
  gap: 12px;
  padding: 16px 24px;
`;

export const PrimaryButton = styled.button`
  align-items: center;
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  cursor: pointer;
  display: flex;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  justify-content: center;
  padding: 12px 24px;
  transition: opacity 0.15s ease;
  width: 100%;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  font-family: Barlow;
  font-size: 13px;
  padding: 8px;
  text-align: center;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.shade200};
  }
`;
